// extracted by mini-css-extract-plugin
module.exports = {"panelTabs":"_31c268c","tab":"_58e03af","selectedTab":"_23aa56b","panel":"_4a9bef8"};